 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781416583226_COV from '@/components/9781416583226_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A781416583226_DED from '@/components/9781416583226_ded'
 import A781416583226_CH01 from '@/components/9781416583226_ch01'
 import A781416583226_CH02 from '@/components/9781416583226_ch02'
 import A781416583226_CH03 from '@/components/9781416583226_ch03'
 import A781416583226_CH04 from '@/components/9781416583226_ch04'
 import A781416583226_CH05 from '@/components/9781416583226_ch05'
 import A781416583226_CH06 from '@/components/9781416583226_ch06'
 import A781416583226_CH07 from '@/components/9781416583226_ch07'
 import A781416583226_CH08 from '@/components/9781416583226_ch08'
 import A781416583226_CH09 from '@/components/9781416583226_ch09'
 import A781416583226_CH10 from '@/components/9781416583226_ch10'
 import A781416583226_APPENDA from '@/components/9781416583226_Appenda'
 import A781416583226_APPENDB from '@/components/9781416583226_Appendb'
 import A781416583226_APPENDC from '@/components/9781416583226_Appendc'
 import A781416583226_APPENDD from '@/components/9781416583226_Appendd'
 import A781416583226_ACK from '@/components/9781416583226_ack'
 import A781416583226_NOTES from '@/components/9781416583226_Notes'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
 import A781416583226_COP from '@/components/9781416583226_cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781416583226_cov",
 			"name" : "9781416583226_cov",
 			"component" : A781416583226_COV
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9781416583226_ded",
 			"name" : "9781416583226_ded",
 			"component" : A781416583226_DED
 		},
 		{
 			"path" : "/9781416583226_ch01",
 			"name" : "9781416583226_ch01",
 			"component" : A781416583226_CH01
 		},
 		{
 			"path" : "/9781416583226_ch02",
 			"name" : "9781416583226_ch02",
 			"component" : A781416583226_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js